import { useSelector, useDispatch } from "react-redux"
import { useCallback } from "react"
import type { AppDispatch } from "../store"
import { 
  loginWithPhone, 
  logout, 
  clearError, 
  selectAuth, 
  selectToken, 
  selectIsAuthenticated, 
  selectAuthLoading, 
  selectAuthError 
} from "../features/auth/authSlice"
// Auth token is now managed in the authSlice

export const useAuth = () => {
  const dispatch = useDispatch<AppDispatch>()
  const auth = useSelector(selectAuth)
  const token = useSelector(selectToken)
  const isAuthenticated = useSelector(selectIsAuthenticated)
  const isLoading = useSelector(selectAuthLoading)
  const error = useSelector(selectAuthError)

  const login = useCallback(async (phoneNumber: string) => {
    try {
      const result = await dispatch(loginWithPhone(phoneNumber)).unwrap()
      return result
    } catch (error) {
      throw error
    }
  }, [dispatch])

  const handleLogout = useCallback(() => {
    dispatch(logout())
  }, [dispatch])

  const clearAuthError = useCallback(() => {
    dispatch(clearError())
  }, [dispatch])

  return {
    // State
    auth,
    token,
    isAuthenticated,
    isLoading,
    error,
    phoneNumber: auth.phoneNumber,
    
    // Actions
    login,
    logout: handleLogout,
    clearError: clearAuthError,
  }
}